<template>
  <main class="article-page">
    <JournalFilters back-button />
    <HeroSection :article="article" />
    <ContentSection :article="article" />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import ContentSection from './ContentSection/ContentSection.vue';
import JournalFilters from '~/components/JournalPage/JournalFilters/JournalFilters.vue';

export default {
  components: {
    JournalFilters,
    HeroSection,
    ContentSection,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ArticlePage.scss';
</style>
